import { MutationTree } from 'vuex';
import { FACTURE_FOURNISSEUR } from './mutation-types';
import { FactureFournisseurState, initialState as resetState } from './state';
import { FactureFournisseurDTO, StatusFacture } from '@/models/FactureFournisseurDTO';
import { SortType } from '@/models/SortType';
import { TableHeader } from '@/models/TableHeader';

export const mutations: MutationTree<FactureFournisseurState> = {

    [FACTURE_FOURNISSEUR.SET_FACTURES](state, factures: FactureFournisseurDTO[]) {
        state.factures = factures;
    },
    [FACTURE_FOURNISSEUR.ADD_FACTURES](state, factures: FactureFournisseurDTO[]) {
        state.factures = [...state.factures, ...factures];
    },
    [FACTURE_FOURNISSEUR.RESET_ITEMS](state) {
        Object.assign(state, resetState);
    },
    [FACTURE_FOURNISSEUR.SET_FILTER_OPERATEUR](state, operateur: string) {
        state.filtreOperateur = operateur;
    },
    [FACTURE_FOURNISSEUR.SET_FILTER_MONTANT](state, montant: number) {
        state.filtreMontant = montant;
    },
    [FACTURE_FOURNISSEUR.SET_FILTER_SOCIETE](state, societe: string) {
        state.filtreSociete = societe;
    },
    [FACTURE_FOURNISSEUR.SET_FILTER_NUMERO_FACTURE](state, numeroFacture: string) {
        state.filtreNumerofacture = numeroFacture;
    },
    [FACTURE_FOURNISSEUR.SET_FILTER_ETAT](state, etats: StatusFacture[]) {
        state.filtreEtat = etats;
    },
    [FACTURE_FOURNISSEUR.SET_FILTER_DATE_DEBUT](state, dateDebut: string) {
        state.filtreDateDebut = dateDebut;
    },
    [FACTURE_FOURNISSEUR.SET_FILTER_DATE_FIN](state, dateFin: string) {
        state.filtreDateFin = dateFin;
    },
    [FACTURE_FOURNISSEUR.SET_FACTURES_LOADING](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [FACTURE_FOURNISSEUR.SET_SORT](
        state,
        sort: {
            sortData: string;
            sortStatus: SortType;
        }
    ) {
        const tableHeader = state.tableHeader.reduce((newTable, headerItem) => {
            if (headerItem.sortData !== sort.sortData) {
                if (headerItem.sortStatus !== SortType.INACTIVE) headerItem.sortStatus = SortType.NONE;
            } else headerItem.sortStatus = sort.sortStatus;
            return[...newTable, headerItem];
        }, [] as TableHeader[]);
        state.tableHeader = tableHeader;
        state.sort = sort;
    },
    [FACTURE_FOURNISSEUR.SET_NUMBER_OF_PAGES](state, nbOfPages: number) {
        state.numberOfPage = nbOfPages;
    },
    [FACTURE_FOURNISSEUR.SET_PAGE](state, page: number) {
        state.page = page;
    },
    [FACTURE_FOURNISSEUR.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },
    [FACTURE_FOURNISSEUR.SET_NB_ELEMENTS](state, nb: number) {
        state.count = nb;
    },
    [FACTURE_FOURNISSEUR.XLS_LOADING](state, isLoading: boolean) {
        state.isXlsLoading = isLoading;
    },
};
